import { toOneDecimalPlace } from './toOneDecimalPlace';
import { Size } from '@/constants';

const { ONE_MB } = Size;

export const getSizeInMB = (sizeInBytes: number) => toOneDecimalPlace(sizeInBytes / ONE_MB);
